import React from 'react';
import { Card, Spin, Typography } from 'antd';
import { LineChartOutlined } from '@ant-design/icons';
import '../../styles/style.scss';

type AnalyticsCardProps = {
  value: React.ReactNode;
  description: string;
  icon?: React.ReactNode;
  smaller?: boolean;
  type?: 'increase' | 'decrease';
  percentageChange?: string;
  previousValue?: string;
  isLoading?: boolean;
};

const AnalyticsCard = ({
  description,
  value,
  icon = <LineChartOutlined />,
  smaller,
  type,
  percentageChange,
  previousValue,
  isLoading,
}: AnalyticsCardProps): JSX.Element => (
  <Spin spinning={isLoading}>
    <Card className={`analytics-card ${smaller ? 'smaller' : ''}`}>
      <div className="card-header">
        <Typography.Text className="description">{description}</Typography.Text>
        <div className="icon">{icon}</div> {/* Render dynamic icon */}
      </div>
      <Typography.Title className="value">{value}</Typography.Title>

      {percentageChange && previousValue && (
        <div className={`change-indicator ${type === 'decrease' ? 'decrease' : 'increase'}`}>
          <span>{type === 'decrease' ? '↓' : '↑'}</span>
          <Typography.Text>{percentageChange}%</Typography.Text>
          <Typography.Text className="prev-value"> vs {previousValue} (prev.)</Typography.Text>
        </div>
      )}
    </Card>
  </Spin>
);

AnalyticsCard.defaultProps = {
  smaller: false,
  type: '',
  icon: <LineChartOutlined />,
  percentageChange: '',
  previousValue: '',
  isLoading: false,
};

export default AnalyticsCard;
